import { useState, useContext } from "react";
import { Modal, Button } from "react-bootstrap";
import { SiteManContext } from "../SiteManContext";
import EditSiteForm from "../EditSiteForm";

const SiteItem = ({ item }) => {
  const { deleteSite } = useContext(SiteManContext);

  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  if (!item) return null;

  const siteId = item.geom_id ?? item.objectid_1 ?? item.objectid;

  const handleDelete = async () => {
    if (siteId) {
      await deleteSite(siteId);
    }
    setShowDelete(false);
  };

  return (
    <>
      <td>{item.objectid_1 || item.geom_id || item.objectid || "-"}</td>
      <td>{item.idpresenze || "-"}</td>
      <td>{item.nome || "-"}</td>
      <td>{item.tipologia || "-"}</td>
      <td>{item.comune || "-"}</td>
      <td>{item["localit�"] || item.localita || "-"}</td>
      <td>{item.stato_di_conservazione || item.stato_conservazione || "-"}</td>
      <td>{item.compilatore || "-"}</td>
      <td>{item.data || "-"}</td>
      <td>{item["visibilit�"] || item.visibilita || "-"}</td>

      {/* Cella con Azioni: Modifica ed Elimina */}
      <td className="text-nowrap">
        {/* Pulsante Modifica (Matita) */}
        <button
          className="btn btn-sm btn-link text-warning p-0 me-2"
          onClick={() => setShowEdit(true)}
          title="Modifica"
        >
          <i className="material-icons">edit</i>
        </button>

        {/* Pulsante Elimina (Cestino Rosso) */}
        <button
          className="btn btn-sm btn-link text-danger p-0"
          onClick={() => setShowDelete(true)}
          title="Elimina"
        >
          <i className="material-icons">delete</i>
        </button>
      </td>

      {/* Modal Modifica */}
      <Modal show={showEdit} onHide={() => setShowEdit(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Modifica Sito</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showEdit && <EditSiteForm site={item} handleClose={() => setShowEdit(false)} />}
        </Modal.Body>
      </Modal>

      {/* Modal Conferma Eliminazione */}
      <Modal show={showDelete} onHide={() => setShowDelete(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Conferma Eliminazione</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Sei sicuro di voler eliminare il sito <strong>{item.nome || `ID: ${siteId}`}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDelete(false)}>
            Annulla
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Elimina
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SiteItem;